/* src/app/views/legal-text-contract/legal-text-contract-bra-dealer-reviews/legal-text-contract-bra-dealer-reviews.component.scss */
.contract-wrapper {
  background: #ffffff;
  border: 1px solid #d8e0eb;
  border-radius: 14px;
  box-shadow: 0 10px 24px rgba(16, 43, 78, 0.08);
  overflow: hidden;
  padding: 0;
  margin: 0 auto 24px;
  width: 100%;
  max-width: none;
}
.page-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  font-family: Ford Antenna;
}
.image-position {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}
.text-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px 20px;
  margin-left: 0;
  width: min(1120px, 100%);
}
.styling-the-title {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-weight: bold;
  margin-top: 20px;
  color: #102b4e;
}
.styling-the-hr {
  height: 2px;
  background-color: #102b4e;
  margin-bottom: 20px;
  width: 100%;
}
.top-element {
  position: relative;
  margin: 14px auto;
  width: 100%;
  max-width: 1120px;
  padding-top: 42px;
}
.header {
  width: min(320px, 100%);
  height: calc(100% - 44px);
  background-color: #102b4e;
  color: white;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  border-radius: 0;
  box-shadow: none;
  padding: 12px 0 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
  min-height: 64px;
  box-sizing: border-box;
}
.header .header-title {
  width: 100%;
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  letter-spacing: 0.3px;
  padding: 0;
  background: transparent;
  margin: 0;
  line-height: 1.2;
}
.info-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
  z-index: 2;
  background-color: #D9E2F3;
  padding: 16px 22px;
  color: #102b4e;
  font-size: 14px;
  line-height: 1.42;
  margin-bottom: 0;
  width: calc(100% - 20px);
  max-width: 100%;
  box-sizing: border-box;
  min-height: 96px;
  height: auto;
}
.first-line h5,
.first-line p {
  margin: 0;
}
.elements-below-each-other .first-line {
  gap: 6px;
}
.top-box {
  min-height: 126px;
  gap: 10px;
}
.top-box-second {
  min-height: 118px;
}
.top-box-third {
  min-height: 92px;
}
.top-box-fourth {
  min-height: 96px;
}
.first-line-position {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  gap: 8px 26px;
  width: 100%;
}
.first-line {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 6px;
}
.first-line h5,
.first-line p {
  font-size: 14px;
  line-height: 1.45;
  margin: 0;
  color: #102b4e;
}
.first-line h5 {
  font-weight: 700;
}
.space {
  margin-left: 0;
  justify-content: flex-start;
}
.space-second {
  margin-left: 0;
  justify-content: flex-start;
}
.space-car-image {
  margin-left: 10px;
}
.space-car-image-second {
  margin-left: 0;
  justify-content: flex-start;
}
.space-sifron-image {
  margin-left: 10px;
  flex: 1 1 520px;
}
.icon-style {
  font-size: 56px;
  color: #000000;
  margin-right: 18px;
  margin-left: 6px;
}
.top-box-third .first-line-position {
  display: grid;
  grid-template-columns: 110px minmax(0, 1fr) 320px;
  column-gap: 24px;
}
.top-box-fourth .first-line-position {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  column-gap: 24px;
}
.top-box .first-line-position {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  column-gap: 24px;
  align-items: center;
}
.contract-paragraph {
  text-align: justify;
  font-size: 15px;
  line-height: 1.6;
  color: #102b4e;
  margin-top: 10px;
}
.contract-paragraph a {
  color: #046cea;
}
.contract-paragraph a:hover {
  color: #044ea7;
}
@media (max-width: 768px) {
  .top-element {
    padding-top: 30px;
  }
  .header {
    width: min(236px, 100%);
    height: auto;
    min-height: 42px;
    align-items: center;
    padding-top: 0;
  }
  .header .header-title {
    font-size: 13px;
    padding: 7px 0;
  }
  .info-box {
    padding: 12px 14px;
  }
  .first-line-position {
    flex-wrap: wrap;
    gap: 8px 12px;
  }
  .space,
  .space-second,
  .space-car-image,
  .space-car-image-second,
  .space-sifron-image {
    margin-left: 0;
    justify-content: flex-start;
    flex: 1 1 100%;
  }
  .icon-style {
    font-size: 42px;
    margin-right: 12px;
    margin-left: 2px;
  }
  .top-box-third .first-line-position,
  .top-box-fourth .first-line-position {
    display: flex;
    grid-template-columns: none;
    column-gap: 0;
  }
}
.bold-words {
  font-weight: bold;
}
.image-paragraph {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
}
.button-position {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  width: calc(100% - 56px);
  margin: 20px 28px 0;
  padding-top: 18px;
  border-top: 1px solid #d9d9d9;
  box-sizing: border-box;
}
.btn-return {
  width: auto;
  min-width: 137px;
  height: 48px;
  padding: 0 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #ffffff;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin-top: 0;
  margin-right: 0;
  color: #046cea;
}
.btn-return-span {
  font-size: 15pt;
  font-weight: 500;
  color: #046cea;
  white-space: nowrap;
}
.btn-return:hover {
  background: #044ea7;
  color: #ffffff;
}
button.btn-return:hover:not(:disabled) .btn-return-span {
  color: #ffffff;
}
.btn-save {
  width: auto;
  min-width: 137px;
  height: 48px;
  padding: 0 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #046cea;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin-top: 0;
  margin-right: 0;
  color: #ffffff;
}
.btn-save-span {
  font-size: 15pt;
  font-weight: 500;
  color: #ffffff;
  white-space: nowrap;
}
.btn-save:hover {
  background: #044ea7;
}
.btn-return i,
.btn-save i {
  color: inherit;
}
.btn-save:disabled,
.btn-return:disabled {
  background-color: #f5f5f5;
  border-color: #aaaaaa;
  cursor: not-allowed;
  opacity: 1;
}
.btn-save:disabled .btn-save-span,
.btn-return:disabled .btn-return-span,
.btn-save:disabled i,
.btn-return:disabled i {
  color: #6f6f6f;
}
.btn-save:disabled:hover,
.btn-return:disabled:hover {
  background-color: #f5f5f5;
}
.btn-download {
  width: min(400px, 100%);
  height: 48px;
  padding: 0 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: #046cea;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin-top: 20px;
  margin-right: 50px;
  color: #ffffff;
}
.btn-download-span {
  font-size: 15pt;
  font-weight: 500;
  color: #ffffff;
  white-space: nowrap;
}
.btn-download:disabled {
  background-color: #f5f5f5;
  border-color: #aaaaaa;
  color: #6f6f6f;
  cursor: not-allowed;
  opacity: 1;
}
.btn-download:disabled .btn-download-span,
.btn-download:disabled i {
  color: #6f6f6f;
}
.btn-download.is-loading {
  background-color: #f5f5f5;
  border-color: #aaaaaa;
  color: #6f6f6f;
}
.btn-download .pi {
  font-size: 18px;
  color: inherit;
}
@media only screen and (max-width: 900px) {
  .top-element {
    max-width: 100%;
  }
  .btn-download {
    width: 100%;
    margin-right: 0;
  }
}
.btn-download:hover:not(:disabled) {
  background: #044ea7;
}
.loading {
  position: absolute;
  top: 35%;
  left: 50%;
  font-size: 60px;
  font-weight: bold;
}
.elements-below-each-other {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
}
@media only screen and (max-width: 900px) {
  .top-element {
    padding-top: 34px;
  }
  .header {
    width: min(260px, 100%);
    height: auto;
    min-height: 44px;
    align-items: center;
    padding-top: 0;
  }
  .info-box {
    min-height: unset;
  }
  .first-line-position {
    flex-wrap: wrap;
    gap: 10px;
  }
}
/*# sourceMappingURL=legal-text-contract-bra-dealer-reviews.component-V3XV72XX.css.map */
